import { SKU } from "@/entities/pricing/model/priceBook";
import { usePriceBook } from "@/entities/pricing/model/usePriceBook";

/**
 * 分身档位的**每秒单价**(修复波 0926 第十一批 B2 #16 → 0927 K4 I 改源)。
 *
 * ★为什么不用 `PriceBook.unit()`:`/pricing/catalog` 的 creditsPerUnit 是 qty=1 时的积分、**向上取整**
 *   (api PricingCatalogService 头注写明:对不足 1 分的线它是上界)。省流版 liveportrait 价表 3.5 分/秒,
 *   目录给 4 —— 卡面标「约 4 积分 / 秒」、页内预估「4 × 秒」都比实扣高 14%。
 * ★B2 #16 的探法(同一规格问一次 dryRun 报价 qty=10,总额 ÷ 10)已退役:后端 0927 起在目录行直接下发
 *   不取整的 `creditsPerUnitExact`(同一条 derive 的分子 ÷ 面值),hub 卡面(`entities/scene-card/catalog.ts`
 *   的 dh_photo)与这里读**同一列**,两处显示的「约 3.5 积分 / 秒」是同一个数;少一跳报价请求。
 * ★取不到(价表没到货 / 该规格查不到 / 老后端没这一列)→ null,调用方显示「—」,不兜整数上界。
 */
export function useDhPerSecondRate(variantKey: string | null | undefined): number | null {
  const { book } = usePriceBook();
  return variantKey ? book.unitExact(SKU.dhRender, variantKey) : null;
}

/** 「3.5」「168」—— 最多一位小数,整数不带 .0。实现搬到价目表层(hub 卡面同用),这里保留出口。 */
export { formatPerSecondRate } from "@/entities/pricing/model/priceBook";
